import { useState } from "react";
import { Container } from "react-bootstrap";
import CustomForm from "../components/CustomForm";
import InspectionForm from "../components/InspectionForm";
import "../assets/scss/pages/inquiry.scss";

const BookInspection = () =>  {
    const [showInspection, setShowInspection] = useState(null);
    const [inquiryId, setInquiryId] = useState(null);
    const [inquiryData, setInquiryData] = useState(null);

    const handleInquirySuccess = (idFromResponse, dataFromForm) => {
        setInquiryId(idFromResponse);
        setInquiryData(dataFromForm);
        // Trigger the slide animation by setting showInspection to true
        // The animation will be handled by CSS transitions
        setTimeout(() => {
            setShowInspection(true);
        }, 100);
    };

    const handleInspectionSuccess = () => {
        // Optionally redirect or show a completion message
        window.location.href = '/';
    };

    return (
        <Container id="inquire" className="my-2 py-5 px-lg-5 bg-white">
            {/* Inquiry Form Section */}
            <div className={`inquiry-section ${showInspection ? 'slide-out' : 'slide-in'}`}>
                <header className="d-flex flex-column gap-3 mx-auto">
                    <h3 className="text-secondary px-4">Book Private Tour</h3>
                    <p className="px-4">Please tell us a bit about what you're looking for, and then we'll move on to booking your inspection.</p>
                </header>
                <CustomForm
                    type="full-inquiry"
                    onFormSubmit={handleInquirySuccess}
                />
            </div>

            {/* Inspection Form Section */}
            {showInspection && (
                <div className="inspection-section slide-in">
                    <header className="d-flex flex-column gap-3 mx-auto">
                        <h3 className="text-secondary px-4">Schedule Your Private Tour</h3>
                        <p className="px-4">Now let's confirm the details and schedule your inspection.</p>
                    </header>
                    <InspectionForm
                        inquiryId={inquiryId}
                        inquiryData={inquiryData}
                        onSuccess={handleInspectionSuccess}
                    />
                </div>
            )}
        </Container>
    );
};

export default BookInspection;